import { Component } from "react";
import PropTypes from "prop-types";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";

import moment from "moment";

export default class FactoringDetails extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div>
        <Card>
          <CardContent>
            <div>Paid parts</div>
            <div className="row">
              <div className="col-md-12">
                {Object.entries(this.props.item.PaidParts).map(
                  ([key, value], paidPartIndex) => {
                    return (
                      <div
                        className="col-md-12"
                        key={`paidparts-${paidPartIndex}`}
                      >
                        {key}: {Math.round(value.Amount * 100) / 100} kr
                      </div>
                    );
                  },
                )}
              </div>
            </div>
          </CardContent>
        </Card>
        <Card>
          <CardContent>
            <div>Payments ({this.props.item.Payments.length})</div>
            <div className="row">
              <div className="col-md-12">
                {this.props.item.Payments.map(
                  (paymentPart, paymentPartIndex) => {
                    return (
                      <div
                        className="col-md-12"
                        key={`paymentparts-${paymentPartIndex}`}
                      >
                        {moment(paymentPart.ReceiveDate).format("YYYY-MM-DD")}:
                        {Object.entries(paymentPart.PaidParts).map(
                          ([key, value], paidPartIndex) => {
                            return (
                              <div
                                className="col-md-12"
                                key={`paymentpartspaid-${paidPartIndex}`}
                              >
                                {key}: {Math.round(value.Amount * 100) / 100} kr
                              </div>
                            );
                          },
                        )}
                      </div>
                    );
                  },
                )}
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    );
  }

  static propTypes = {
    item: PropTypes.object.isRequired,
  };
}
